import useText from "@/composable/components/text";
import { Ref } from "vue";
import services from "@/composable/services";
import { Locales } from "@/utils/LocaleUtils";

const chosenLocale: Ref<string> = useText().refText;
const locales = Locales;

const setUserPrefLocale = (): void => {
  window.location.reload();
  services.userPreferencesService.setUserPrefLocale(chosenLocale.value);
};
export { chosenLocale as chosenLocale, locales as locales, setUserPrefLocale as setUserPrefLocale };
